import { render, staticRenderFns } from "./BenefitsIcons.vue?vue&type=template&id=d6c86628"
import script from "./BenefitsIcons.vue?vue&type=script&lang=js"
export * from "./BenefitsIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports